( function( $, window, document, undefined ) {

	var $image = $('.js-color-image-target'),
			$caption = $('.js-color-image-name'),

			swatch_selected = 'color-swatches__item--is-selected';

	/**
	 * Store the current values of the image and caption as data- attributes.
	 */
	function store_current_values() {
		$image.attr( {
			'data-image-original-src': $image.attr('src'),
		} );

		$caption.attr( {
			'data-image-original-text': $caption.html(),
		} );
	}

	/**
	 * Restore the original values from the data- attributes.
	 */
	function restore_original_values() {
		$image.attr( {
			'src': $image.attr('data-image-original-src'),
		} );

		$caption.html( $caption.attr('data-image-original-text') );

		// Clear data- attributes
		$image.attr( {
			'data-image-original-src': ''
		} );

		$caption.attr( {
			'data-image-original-text': '',
		} );
	}

	/**
	 * Replace the values on the image and caption with the provided ones.
	 * If the original values haven't been stored previously, store them.
	 * @param  {String} image_src
	 * @param  {String} name
	 */
	function replace_values( image_src, name ) {
		if ( undefined === $image.attr( 'data-image-original-src' ) || '' === $image.attr( 'data-image-original-src' ) ) {
			store_current_values();
		}

		$image.attr( 'src', image_src );
		$caption.html( name );
	}

	/**
	 * Choose whether to restore the original values or show the swatch values.
	 * @param  {String} image_src
	 * @param  {String} name
	 */
	function maybe_show_original( image_src, name ) {
		if ( '' != image_src ) {
			// If there is an image for this color swatch, load it
			replace_values( image_src, name );
			return true;
		}

		return false;
	}

	// Bind events
	$(document).on( 'click touchstart', '[data-image-color-src]', function(event) {
		// Check $image exists
		if ( $image.length < 1 ) {
			return;
		}

		var swatch_src = $(this).attr('data-image-color-src'),
				swatch_name = $(this).attr('data-image-color-name'),
				result = maybe_show_original( swatch_src, swatch_name );

		if ( result ) {
			$('.' + swatch_selected).removeClass( swatch_selected );
			$(this).addClass( swatch_selected );
		}

		event.preventDefault();
		event.stopPropagation();
		return false;
	} );

} )( jQuery, window, document );
